import Router from "./Router/Router";
import { ConfigProvider, theme } from "antd";
const { defaultAlgorithm } = theme;

function App() {
  return (
    <ConfigProvider
      theme={{
        algorithm: defaultAlgorithm,
        token: {
          colorPrimary: "#1677ff",
        },
      }}
    >
      <Router />
    </ConfigProvider>
  );
}

export default App;
